import { env } from '~/config/env';

export function getExamName() {
  switch (env.VITE_APP) {
    case 'usmle':
      return 'USMLE® Step 1';
    case 'ems':
      return 'NREMT®';
    case 'msp':
      return 'MEDSchool Pack';
    case 'mcat':
      return 'MCAT';
    default:
      throw new Error('Invalid tenant');
  }
}

export function getExamNameShort() {
  switch (env.VITE_APP) {
    case 'usmle':
      return 'USMLE®';
    case 'ems':
      return 'EMS';
    case 'msp':
      return 'MSP';
    case 'mcat':
      return 'MCAT';
    default:
      throw new Error('Invalid tenant');
  }
}

export function getExamQuestionCount() {
  switch (env.VITE_APP) {
    case 'usmle':
      return '2500';
    case 'ems':
      return '3550';
    case 'msp':
      return '21 000';
    case 'mcat':
      return '3 600';
    default:
      throw new Error('Invalid tenant');
  }
}
